// src/redux/slices/gameSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {Tokens, User, Leader, Metadata} from '../types';
interface GameState {
    user: User;
    authTokens: Tokens;
    isAuthorized: boolean,
    isLoaded: boolean,
    loadProgress: number,
    currentModal: string;
    secondaryModal: string;
    runningRequest: boolean;
    toast: string;
    lastSyncAt: number;
    isNetworkError: boolean;
    sendRequestFunc: string,
    sendRequestData: {},
    showPromo: number;
    isPlayingMusic: boolean;
    dismissedTasksPopup: boolean;
    // Add other relevant state properties here

    leaderboard: Leader[];
    metadata: Metadata;
    presalePopupShown: boolean;
}

const initialState: GameState = {
    user: { id: 0, avatar: '', airdrop_address: '', tokens: 0, tickets: 0, friends: 0, active_state: 0, username: '', language_code: '', app_language: 'en', ref_code: '', seconds_to_claim: 0 },
    authTokens: { access_token: '', refresh_token: '', expires_in: 0 },
    isAuthorized: false,
    isLoaded: false,
    loadProgress: 0,
    currentModal: "",
    secondaryModal: '',
    runningRequest: false,
    toast: '',
    lastSyncAt: new Date().getTime(),
    isNetworkError: false,
    sendRequestFunc: '',
    sendRequestData: {},
    showPromo: 0,
    isPlayingMusic: false,
    dismissedTasksPopup: false,
    leaderboard: [],
    metadata: {time_to_presale: 0, users_waitlist: 0, telegram: '', twitter: '', bot: '', is_airdrop: false, is_presale: false},
    presalePopupShown: false,
};

const gameSlice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<User>) {
            state.user = action.payload;
        },
        showPromo(state, action: PayloadAction<number>) {
            if (action.payload === 0)
                state.showPromo = action.payload;
            else
                state.showPromo += 1;
        },
        setIsNetworkError(state, action: PayloadAction<boolean>) {
            state.isNetworkError = action.payload;
        },
        setSendRequestFunc(state, action: PayloadAction<string>) {
            state.sendRequestFunc = action.payload;
        },
        setSendRequestData(state, action: PayloadAction<{}>) {
            state.sendRequestData = action.payload;
        },
        setAuthTokens(state, action: PayloadAction<Tokens>) {
            state.authTokens = action.payload;
        },
        setRunningRequest(state, action: PayloadAction<boolean>) {
            state.runningRequest = action.payload;
        },
        showToast(state, action: PayloadAction<string>) {
            state.toast = action.payload;
        },
        setAddress(state, action: PayloadAction<string>) {
            state.user.airdrop_address = action.payload;
        },
        setTickets(state, action: PayloadAction<number>) {
            state.user.tickets = action.payload;
        },
        setTokens(state, action: PayloadAction<number>) {
            state.user.tokens = action.payload;
        },
        setFriends(state, action: PayloadAction<number>) {
            state.user.friends = action.payload;
        },
        setSecondsToClaim(state, action: PayloadAction<number>) {
            state.user.seconds_to_claim = action.payload;
        },
        setAuthorization(state, action: PayloadAction<boolean>) {  // Add this action
            state.isAuthorized = action.payload;
        },
        setAppLanguage(state, action: PayloadAction<string>) {
            state.user.app_language = action.payload;
        },
        setIsLoaded(state, action: PayloadAction<boolean>) {
            state.isLoaded = action.payload;
        },
        setCurrentModal(state, action: PayloadAction<string>) {
            state.currentModal = action.payload;
        },
        setLeaderboard(state, action: PayloadAction<Leader[]>) {
            state.leaderboard = action.payload;
        },
        setMetadata(state, action: PayloadAction<Metadata>) {
            state.metadata = action.payload;
        },
        setActiveState(state, action: PayloadAction<number>) {
            state.user.active_state = action.payload;
        },
        setPresalePopupShown(state, action: PayloadAction<boolean>) {
            state.presalePopupShown = action.payload;
        }
    },
});

export const { setSendRequestFunc, setSendRequestData, setCurrentModal, setIsNetworkError, showToast, setRunningRequest, setUser, setAuthTokens, setAuthorization, setAppLanguage, setIsLoaded, setAddress, setTickets, setTokens, setFriends, setSecondsToClaim, setActiveState, setLeaderboard, setMetadata,setPresalePopupShown } = gameSlice.actions;
export default gameSlice.reducer;
